import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import { useAuth } from '../../contexts/AuthContext';
import { getBlockedProfiles, getOwnReports, unblockUser } from '../../services/safetyService';
import './SafetyCenterPage.css';

const dateLabel = (value) => value?.toDate?.()?.toLocaleString?.() || 'Submitted';

export default function SafetyCenterPage() {
  const { user, loading } = useAuth();
  const [reports, setReports] = useState([]);
  const [blocked, setBlocked] = useState([]);
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    if (!user) return;
    try {
      const [nextReports, nextBlocked] = await Promise.all([getOwnReports(user.uid), getBlockedProfiles(user.uid)]);
      setReports(nextReports);
      setBlocked(nextBlocked);
    } catch (err) {
      setError(err.message || 'Safety information could not be loaded.');
    }
  };

  useEffect(() => { load(); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <main className="p4r-safety-center"><div>Loading…</div></main>;
  if (!user) return <main className="p4r-safety-center"><div><h1>Safety center</h1><p>Sign in to review blocked accounts and reports you submitted.</p><Link to="/login">Sign in</Link></div></main>;

  return (
    <main className="p4r-safety-center">
      <Seo title="Safety Center | Pool 4 Real" description="Review Pool 4 Real reports and blocked accounts." path="/safety" robots="noindex,follow" />
      <div className="p4r-safety-shell">
        <header><p>Account controls</p><h1>Safety center</h1><span>Review reports you submitted and manage blocked player accounts.</span></header>
        {error && <div className="p4r-safety-error">{error}</div>}
        <section>
          <h2>Blocked accounts</h2>
          {blocked.length === 0 ? <p>No blocked accounts.</p> : blocked.map((profile) => (
            <article key={profile.id}>
              <img src={profile.profileImageUrl || '/assets/pool4real-app-icon.png'} alt="" />
              <div><strong>{profile.nickname || 'Pool 4 Real user'}</strong><span>{profile.bio || 'Blocked account'}</span></div>
              <button disabled={busy === profile.id} onClick={async () => {
                if (!window.confirm('Unblock this account? They may be able to interact with you again.')) return;
                setBusy(profile.id);
                try { await unblockUser({ uid: user.uid, targetUid: profile.id }); await load(); } catch (err) { setError(err.message); } finally { setBusy(''); }
              }}>{busy === profile.id ? 'Updating…' : 'Unblock'}</button>
            </article>
          ))}
        </section>
        <section>
          <h2>Reports submitted</h2>
          {reports.length === 0 ? <p>No reports submitted.</p> : reports.map((report) => (
            <article key={`${report.collectionName}-${report.id}`} className="report-row">
              <div><strong>{report.type}</strong><span>{report.reason || 'Report'} • {dateLabel(report.timestamp)}</span></div>
              <span className="status">{report.status || 'Under Review'}</span>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}
